import React from 'react';
import { Link } from 'react-router-dom';
import { LEGAL_CONTACT_EMAIL, LEGAL_ENTITY_NAME } from '../config/legal';

/**
 * Site-wide footer with legal links and contact.
 */
export const SiteFooter: React.FC = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer" role="contentinfo">
      <nav className="site-footer-nav" aria-label="Legal and site links">
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/terms">Terms of Service</Link>
        <Link to="/privacy#cookies">Cookies</Link>
        <a href={`mailto:${LEGAL_CONTACT_EMAIL}`}>{LEGAL_CONTACT_EMAIL}</a>
      </nav>
      <p className="site-footer-copy">
        © {year} {LEGAL_ENTITY_NAME}. All rights reserved.
      </p>
    </footer>
  );
};

export default SiteFooter;
